import { PropsWithChildren, useState } from 'react';
import { cn } from '@sandtech-hub-monorepo/ui-kit';
import { CaretUpIcon } from '@radix-ui/react-icons';

interface Props extends PropsWithChildren {
  name: string;
  initialExpanded: boolean;
}

export const CoursesGroupView = ({
  name,
  initialExpanded,
  children,
}: Props) => {
  const [expanded, setExpanded] = useState(initialExpanded);

  return (
    <>
      <div
        onClick={() => setExpanded(!expanded)}
        className="flex justify-between items-center py-4 px-6 bg-success/5 border-b border-b-heading text-heading font-semibold select-none cursor-pointer"
      >
        {name}
        <CaretUpIcon
          width={32}
          height={32}
          className={cn(
            'transition-transform',
            expanded ? 'rotate-180' : 'rotate-0'
          )}
        />
      </div>
      <div
        className={cn(
          'grid transition-[grid-template-rows,_opacity] duration-300',
          expanded ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
        )}
      >
        <div className="overflow-hidden">{children}</div>
      </div>
    </>
  );
};
